export default __webpack_public_path__ + "static/media/matchInvestor.0aa730cb.png";